/**
 * Backend sometimes prepends the API host to an already-absolute S3 URL, e.g.
 * https://carsapi.saldr.tech/https://bucket.s3.amazonaws.com/...
 * Extract the real URL — never add a base URL prefix.
 */
export function sanitizeImageUrl(url) {
  if (!url || typeof url !== "string") {
    return "";
  }

  let trimmed = url.trim();
  if (!trimmed) {
    return "";
  }

  if (trimmed.startsWith("/http://") || trimmed.startsWith("/https://")) {
    trimmed = trimmed.slice(1);
  }

  const nestedAbsolute = trimmed.match(/^https?:\/\/[^/]+\/(https?:\/\/.+)$/i);
  if (nestedAbsolute) {
    return nestedAbsolute[1];
  }

  return trimmed;
}

const IMAGE_ARRAY_KEYS = [
  "exterior_images_",
  "wheels_images_",
  "treads_images_",
  "interior_images_",
  "damage_images_",
];

export function sanitizeCarPicsPayload(payload) {
  if (!payload || typeof payload !== "object") {
    return payload;
  }

  const hasDataWrapper =
    payload.data &&
    typeof payload.data === "object" &&
    !Array.isArray(payload.data);

  const source = hasDataWrapper ? payload.data : payload;
  const looksLikeImageCollection = IMAGE_ARRAY_KEYS.some((key) =>
    Array.isArray(source[key])
  );

  if (looksLikeImageCollection) {
    const inner = { ...source };

    IMAGE_ARRAY_KEYS.forEach((key) => {
      if (Array.isArray(inner[key])) {
        inner[key] = inner[key].map((item) => ({
          ...item,
          image: sanitizeImageUrl(item?.image),
        }));
      }
    });

    return hasDataWrapper ? { ...payload, data: inner } : inner;
  }

  if (source?.image !== undefined) {
    const normalized = {
      ...source,
      image: sanitizeImageUrl(source.image),
    };
    return hasDataWrapper ? { ...payload, data: normalized } : normalized;
  }

  return payload;
}
